<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="" name="0">
        <img src="/static/images/introduce-wms.png" >
      </el-tab-pane>
    </el-tabs>
    <div class="detail">通过入库业务、出库业务、仓库调拨、库存调拨等功能，综合实现批次管理、物料对应、库存盘点、质检管理等功能的管理系统，进而有效控制并跟踪仓库业务的物流和成本管理全过程，实现完善的企业仓储信息管理。</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: '0'
      }
    },
    mounted: function() {
      if (this.$global.getUrlKey("tab")) this.activeName = this.$global.getUrlKey("tab");
    }
  }
</script>

<style>
  .el-tabs__header {
    margin-bottom: 22px;
  }

  .el-tabs__nav-wrap:after {
    background-color: transparent;
  }

  .el-tabs__active-bar {
    width: 50px;
    height: 3px;
    background-color: #fff;
    border-radius: 1.5px;
  }

  .el-tabs__item {
    font-size: 16px;
    color: #e1e1e1;
  }

  .el-tabs__item.is-active,.el-tabs__item:hover {
    font-size: 18px;
    color: #fff;
  }

  .stance {
    height: 41px;
    margin-bottom: 22px;
  }

  .detail {
    margin-top: 25px;
    font-size: 14px;
    color: #e1e1e1;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/wms.vue